import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useMutation } from 'react-apollo';
import { confirmGoogleCalendarConsentContext } from '@kiper/account-graphql/google-calendar/mutation';
import { CONSENT_CONFIRMATION_STATUS, CONSENT_STATUS } from '../constants';

const statusByConfirmation = {
  [CONSENT_CONFIRMATION_STATUS.expired]: CONSENT_STATUS.expired,
  [CONSENT_CONFIRMATION_STATUS.alreadyDone]: CONSENT_STATUS.alreadyDone,
};

const useConfirmConsentContext = ({ session, selectedOptionId, setStatus }) => {
  const history = useHistory();
  const [confirmConsentContext] = useMutation(
    confirmGoogleCalendarConsentContext,
  );

  const confirm = useCallback(async () => {
    if (!selectedOptionId) {
      setStatus(CONSENT_STATUS.noSelection);
      return;
    }

    setStatus(CONSENT_STATUS.sending);

    try {
      const { data } = await confirmConsentContext({
        variables: { session, optionId: selectedOptionId },
      });
      const confirmation = data && data.confirmGoogleCalendarConsentContext;
      const failureStatus =
        confirmation && statusByConfirmation[confirmation.status];

      if (failureStatus) {
        setStatus(failureStatus);
        return;
      }

      const syncSession = confirmation && confirmation.syncSession;

      history.replace(
        syncSession
          ? `/calendar/syncing#session=${encodeURIComponent(syncSession)}`
          : '/calendar/welcome',
      );
    } catch (error) {
      setStatus(CONSENT_STATUS.failed);
    }
  }, [confirmConsentContext, history, session, selectedOptionId, setStatus]);

  return { confirm };
};

export default useConfirmConsentContext;
